import { BankAccountTypeEnum, BankConnection, BankConnectionUpdateStatusEnum } from "@finway-group/shared/lib/models"
import { validObjectId, BIC } from "./shared"

export const bankConnection: any = {
    _id: validObjectId,
    connectionId: validObjectId,
    bankName: "Deutsche Bank",
    bankCode: BIC,
    isDefault: true,
    availableInterfaces: [],
    connectedInterfaces: [],
    accounts: [
        {
            _id: validObjectId,
            accountId: validObjectId,
            accountName: "Finway",
            isDefault: true,
            accountType: BankAccountTypeEnum.CHECKING,
            status: BankConnectionUpdateStatusEnum.DOWNLOADING,
        },
    ],
    status: BankConnectionUpdateStatusEnum.DOWNLOADING,
}
